import { FieldArray, useFormField } from '@calendly/form';
import { useInputId } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recipientFieldsStatusSelector } from '../selectors';
import { updateRecipientFieldStatus } from '../slice';
import { ContactsContainer } from './components/contacts_container';
import { FieldWrapper, FieldLabel } from './field_parts';
const buttonWrapperCss = "b68niw4";
const ButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonWrapperCss, props.className)} />;
});
const ExtraToFieldButton = ({
  hideButton,
  recipientType,
  buttonText
}) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(updateRecipientFieldStatus({
      field: recipientType,
      status: true
    }));
  };
  if (hideButton) return null;
  return <ButtonWrapper>
      <Button decoration="ghost" size="small" onClick={onClick} data-testid={`${recipientType}-button`} tabIndex={0} role="button">
        {buttonText}
      </Button>
    </ButtonWrapper>;
};
const dividerCss = "dk6yv47";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)} />;
});
const toFieldActionsCss = "txlz9r3";
export const ToField = () => {
  const id = useInputId();
  const [{
    value: toRecipients
  }, meta] = useFormField({
    name: 'to'
  });
  const [{
    value: isToFieldLocked
  }] = useFormField({
    name: 'isToFieldLocked'
  });
  const error = meta.touched && meta.error;
  const recipientFieldsStatuses = useSelector(recipientFieldsStatusSelector);
  const showCcBccButtons = !(recipientFieldsStatuses.bcc && recipientFieldsStatuses.cc);
  const showCcDivider = !isToFieldLocked && showCcBccButtons && toRecipients.length === 0;
  return <FieldWrapper invalid={Boolean(error)}>
      <FieldLabel htmlFor={id}>
        {I18n.t('publisher.send_from_calendly.field_caption.to')}
        <span aria-hidden>:</span>
      </FieldLabel>
      <FieldArray name="to" render={helpers => <ContactsContainer {...helpers} id={id} fieldName="to" placeholderText={I18n.t('publisher.send_from_calendly.field_caption.placeholder')} isSingleSelection isDisabled={isToFieldLocked} />} />
      <div className={toFieldActionsCss}>
        {showCcDivider && <Divider data-testid="to-cc-divider" />}
        <ExtraToFieldButton hideButton={recipientFieldsStatuses.cc} buttonText="Cc" recipientType="cc" />
        <ExtraToFieldButton hideButton={recipientFieldsStatuses.bcc} buttonText="Bcc" recipientType="bcc" />
      </div>
    </FieldWrapper>;
};

require("./to_field.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./to_field.js");